import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import * as React from 'react';
import { FlexBox } from '../box';
import { Divider } from '../divider';
import { IconDragIndicator } from '../icon';
import { styled } from '../styled';
const DRAGGING_BOX_SHADOW = '0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 6px rgba(0, 0, 0, 0.05)';
const DragHandle = styled(FlexBox)(({ theme, $isOverlay, $isDragging }) => ({
    cursor: $isOverlay || $isDragging ? 'grabbing' : 'grab',
    userSelect: 'none',
    color: theme.palette.action.active,
    flexShrink: 0,
    flexGrow: 0,
    width: theme.spacing(3.75),
    '&:active': $isOverlay
        ? undefined
        : {
            cursor: 'grabbing'
        }
}));
const ItemContainer = styled(FlexBox)(({ theme, $isOverlay, $isDragging, $withoutHandle, $itemTransform, $itemTransition }) => ({
    opacity: $isDragging ? 0.5 : 1,
    outline: $isDragging
        ? `1px dashed ${theme.palette.primary.light}`
        : undefined,
    boxShadow: $isOverlay ? theme.shadows[2] : undefined,
    cursor: $withoutHandle
        ? $isOverlay || $isDragging
            ? 'grabbing'
            : 'grab'
        : undefined,
    transform: $itemTransform,
    transition: $itemTransition,
    ...(!$isDragging && {
        '&:hover': {
            backgroundColor: theme.palette.primary._states?.hover
        }
    }),
    ...($isDragging && {
        backgroundColor: theme.palette.primary._states?.hover,
        boxShadow: DRAGGING_BOX_SHADOW
    }),
    ...($isOverlay && {
        boxShadow: DRAGGING_BOX_SHADOW
    })
}));
export const SortableItem = ({ item, id, isOverlay, renderItem, dragHandleAriaLabel, dragHandlePosition = 'start', withoutDivider = false, withoutHandle = false }) => {
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({ id, disabled: isOverlay });
    const itemTransform = isOverlay
        ? undefined
        : CSS.Transform.toString(transform);
    const itemTransition = isOverlay ? undefined : transition;
    const dragHandle = !withoutHandle ? (_jsx(DragHandle, { ref: isOverlay ? undefined : setActivatorNodeRef, ...(isOverlay ? {} : attributes), ...(isOverlay ? {} : listeners), vAlign: "center", hAlign: "center", "aria-label": dragHandleAriaLabel, paddingLeft: dragHandlePosition === 'start' ? 1 : undefined, paddingRight: dragHandlePosition === 'end' ? 1 : undefined, "$isOverlay": isOverlay, "$isDragging": isDragging, children: _jsx(IconDragIndicator, { fontSize: "small" }) })) : null;
    return (_jsxs(_Fragment, { children: [_jsxs(ItemContainer, { ref: isOverlay ? undefined : setNodeRef, "$isOverlay": isOverlay, "$isDragging": isDragging, "$withoutHandle": withoutHandle, "$itemTransform": itemTransform, "$itemTransition": itemTransition, vAlign: "center", ...(withoutHandle && !isOverlay ? attributes : {}), ...(withoutHandle && !isOverlay ? listeners : {}), children: [dragHandlePosition === 'start' && dragHandle, renderItem(item, { isOverlay, isDragging }), dragHandlePosition === 'end' && dragHandle] }), !isOverlay && !withoutDivider && _jsx(Divider, {})] }));
};
